export default {
    methods: {
        join() {
            let data = {}

            if (this.period.special_price) {
                data.special = false
                data.special_price = this.period.special_price
            } else if(this.$route.name == 'registration.special') {
                data.special = true
            }

            this.$api.post(`tryoutPeriod/${this.period.id}/enroll`, data, { loader: 'join' })
                .then(() => {
                    this.$tracking.event.program.register(this.period.title)
                    this.getEnrollments()
                })
        },

        getEnrollments() {
            this.$api.get('enrollment', { loader: 'join' })
                .then(response => {
                    this.$store.set('enrollment/enrollments', response.data.enrollments)

                    this.$store.dispatch('enrollment/selectByPeriodId', this.period.id)
                    localStorage.setItem('lastSelectedPeriodId', this.period.id)

                    this.$router.replace({ name: 'payment' })
                })
        }
    }
}
